import { render } from "./ReportTextWrapper.vue?vue&type=template&id=1633dc6a&scoped=true"
import script from "./ReportTextWrapper.vue?vue&type=script&lang=js"
export * from "./ReportTextWrapper.vue?vue&type=script&lang=js"

import "./ReportTextWrapper.vue?vue&type=style&index=0&id=1633dc6a&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1633dc6a"]])

export default __exports__